import * as types from './actionTypes';
import * as api from '../components/EstimateCard/AddToOrder/api';

export default (calculateTaxModel, designId) => async (dispatch) => {
  const payload = { designId };
  try {
    const result = await api.EstimateTax(calculateTaxModel);
    if (result.data.WasTaxSuccessful) {
      dispatch({
        type: types.CALCULATE_TAX_SUCCESS,
        payload: {
          ...payload,
          tax: result.data.TaxAmount,
        },
      });
    } else {
      dispatch({ type: types.CALCULATE_TAX_FAIL, payload: { ...payload, tax: 0 } });
    }
  } catch (e) {
    dispatch({ type: types.CALCULATE_TAX_FAIL, payload: { ...payload, tax: 0 } });
  }
};
